export type WorksheetStrictnessEnvironment = 'dev' | 'test' | 'prod'

export type WorksheetStrictness = {
  environment: WorksheetStrictnessEnvironment
  strictNoFallbacks: boolean
  strictnessKey: 'strict' | 'relaxed'
}

const truthyFlag = (value: unknown): boolean =>
  ['1', 'true', 'yes', 'on'].includes(String(value ?? '').trim().toLowerCase())

const falseyFlag = (value: unknown): boolean =>
  ['0', 'false', 'no', 'off'].includes(String(value ?? '').trim().toLowerCase())

export const resolveWorksheetStrictnessEnvironment = (): WorksheetStrictnessEnvironment => {
  const mode = String((import.meta as any)?.env?.MODE ?? '').trim().toLowerCase()
  if (mode === 'test') return 'test'
  if (Boolean((import.meta as any)?.env?.DEV)) return 'dev'
  return 'prod'
}

export const resolveWorksheetStrictness = (opts?: {
  environment?: WorksheetStrictnessEnvironment
  windowLike?: {
    location?: { search?: string | null } | null
    localStorage?: { getItem?: (key: string) => string | null } | null
  } | null
}): WorksheetStrictness => {
  const environment = opts?.environment ?? resolveWorksheetStrictnessEnvironment()
  if (environment === 'dev' || environment === 'test') {
    return {
      environment,
      strictNoFallbacks: true,
      strictnessKey: 'strict',
    }
  }

  const windowLike = opts?.windowLike ?? (typeof window !== 'undefined' ? window : null)
  let strictNoFallbacks = true
  try {
    const sp = new URLSearchParams(String(windowLike?.location?.search ?? ''))
    const qp = String(sp.get('fg_ws_pipeline_strict') ?? '').trim()
    if (qp) {
      strictNoFallbacks = falseyFlag(qp) ? false : truthyFlag(qp)
    } else {
      const ls = String(windowLike?.localStorage?.getItem?.('fg_ws_pipeline_strict') ?? '').trim()
      if (ls) strictNoFallbacks = falseyFlag(ls) ? false : truthyFlag(ls)
    }
  } catch {
    strictNoFallbacks = true
  }

  return {
    environment,
    strictNoFallbacks,
    strictnessKey: strictNoFallbacks ? 'strict' : 'relaxed',
  }
}

